/* ============================================
   Popular Products — App Proxy Client
   ============================================ */

(function() {
  var container = document.getElementById('PopularProductsApp');
  if (!container) return;

  var config = JSON.parse(document.getElementById('popular-products-config').textContent);
  var grid = container.querySelector('[data-product-grid]');
  var countEl = container.querySelector('[data-product-count]');
  var filterSidebar = container.querySelector('[data-filter-sidebar]');
  var brandBar = container.querySelector('[data-brand-bar]');
  var loadingEl = container.querySelector('[data-loading]');

  var COLLECTION_HANDLE = config.collectionHandle;
  var HIDE_SOLD_OUT = config.hideSoldOut;
  var HIDE_NO_IMAGE = config.hideNoImage;
  var ONE_PER_VENDOR = config.onePerVendor;
  var SOURCE_TYPE = config.sourceType;
  var SHOW_VENDOR = config.showVendor;
  var MAX_PRODUCTS = 50;
  var CARD_STYLE = config.cardStyle || 'default';

  var CACHE_KEY = 'popular_random_order_v3';
  var CACHE_TTL = 24 * 60 * 60 * 1000;

  function formatMoney(amount) {
    var num = parseFloat(amount);
    if (isNaN(num)) return '0,00TL';
    var val = num.toFixed(2);
    var parts = val.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + 'TL';
  }

  function escapeAttr(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // App badge'lerini (product-badges snippet'iyle aynı markup/CSS) client-side render eder.
  // p.badges: [{ name, icon, iconImage, background, textColor, position }] — API'den gelir.
  function buildBadgesHTML(p) {
    var badges = p && p.badges;
    if (!badges || !badges.length) return '';
    var positions = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
    var html = '';
    positions.forEach(function(pos) {
      var inPos = badges.filter(function(b) {
        return ((b.position || 'top-left') + '').trim() === pos;
      });
      if (!inPos.length) return;
      var inner = '';
      inPos.forEach(function(b) {
        if (b.iconImage) {
          inner += '<img src="' + escapeAttr(b.iconImage) + '" alt="' + escapeAttr(b.name || '') + '" width="65" height="65" loading="lazy" class="product-badge product-badge--image">';
        } else if (b.name) {
          var bg = escapeAttr(b.background || '#e74c3c');
          var col = escapeAttr(b.textColor || '#ffffff');
          var iconSpan = b.icon ? '<span aria-hidden="true">' + escapeAttr(b.icon) + '</span> ' : '';
          inner += '<span class="product-badge product-badge--text" style="background-color:' + bg + ';color:' + col + ';">' + iconSpan + escapeAttr(b.name) + '</span>';
        }
      });
      if (inner) {
        html += '<div class="product-badges-corner product-badges-corner--' + pos + '">' + inner + '</div>';
      }
    });
    return html;
  }

  function buildRatingHTML(p) {
    if (!p || !p.reviewSummary) return '';
    var count = parseInt(p.reviewSummary.count, 10) || 0;
    if (count <= 0) return '';
    var avg = parseFloat(p.reviewSummary.average) || 0;
    var tenths = Math.floor(avg * 10 + 0.0001);
    var display = (tenths / 10).toString().replace('.', ',');
    var pct = Math.max(0, Math.min(100, tenths * 2));
    var STAR = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    var stars = STAR + STAR + STAR + STAR + STAR;
    return '<div class="card-product__rating" aria-label="' + display + ' üzerinden 5 — ' + count + ' değerlendirme">' +
      '<span class="card-product__rating-value">' + display + '</span>' +
      '<span class="card-product__rating-stars" aria-hidden="true">' +
        '<span class="card-product__rating-stars-track">' + stars + '</span>' +
        '<span class="card-product__rating-stars-fill" style="width: ' + pct + '%;">' + stars + '</span>' +
      '</span>' +
      '<span class="card-product__rating-count">(' + count + ')</span>' +
    '</div>';
  }

  function buildCardHTML(p) {
    var url = p.url || ('/products/' + p.handle);
    var available = p.available;
    var vendor = p.vendor || '';
    var title = p.title || '';
    var variantId = p.variantId || '';
    var price = parseFloat(p.price) || 0;
    var compareAtPrice = p.compareAtPrice ? parseFloat(p.compareAtPrice) : 0;
    var onSale = compareAtPrice > price;
    var discountPct = onSale ? Math.round((compareAtPrice - price) / compareAtPrice * 100) : 0;

    var imgHTML = '';
    if (p.featuredImage && p.featuredImage.url) {
      var imgUrl = p.featuredImage.url;
      if (imgUrl.indexOf('?') === -1) imgUrl += '?width=600';
      else imgUrl += '&width=600';
      imgHTML = '<img src="' + imgUrl + '" alt="' + escapeAttr(p.featuredImage.alt || title) + '" loading="lazy" width="600" class="card-product__image card-product__image--primary">';
    }

    var secondaryImgHTML = '';
    if (p.secondaryImage && p.secondaryImage.url) {
      var secImgUrl = p.secondaryImage.url;
      if (secImgUrl.indexOf('?') === -1) secImgUrl += '?width=600';
      else secImgUrl += '&width=600';
      secondaryImgHTML = '<img src="' + secImgUrl + '" alt="' + escapeAttr(p.secondaryImage.alt || title) + '" loading="lazy" width="600" class="card-product__image card-product__image--secondary">';
    }

    var shippingBadgeHTML = '';
    if (p.freeShipping) {
      shippingBadgeHTML = '<span class="card-product__badge card-product__badge--shipping">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>' +
        'Ücretsiz Kargo</span>';
    }

    var priceHTML = '';
    if (onSale) {
      priceHTML = '<div class="price price--on-sale">' +
        '<span class="price__compare"><s class="price__compare-amount">' + formatMoney(compareAtPrice) + '</s></span>' +
        '<span class="price__regular"><span class="price__amount">' + formatMoney(price) + '</span></span>' +
        '<span class="price__discount">%' + discountPct + ' indirim</span>' +
        '</div>';
    } else {
      priceHTML = '<div class="price">' +
        '<span class="price__regular"><span class="price__amount">' + formatMoney(price) + '</span></span>' +
        '</div>';
    }

    if (!available) {
      priceHTML += '<span class="badge badge--sold-out">Tükendi</span>';
    }

    var vendorHTML = SHOW_VENDOR && vendor ? '<span class="card-product__vendor">' + escapeAttr(vendor) + '</span>' : '';

    var addToCartHTML = '';
    if (available) {
      addToCartHTML = '<button type="button" class="card-product__add-to-cart" data-variant-id="' + variantId + '" data-add-to-cart aria-label="Sepete Ekle - ' + escapeAttr(title) + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
        'Sepete Ekle</button>';
    } else {
      addToCartHTML = '<button type="button" class="card-product__add-to-cart card-product__add-to-cart--sold-out" disabled>Tükendi</button>';
    }

    var wishlistHTML = '<button type="button" class="card-product__wishlist-action wishlist-btn" data-product-wishlist data-product-id="' + p.id + '" data-variant-id="' + variantId + '" aria-label="Favorilere Ekle" aria-pressed="false">' +
      '<svg class="wishlist-btn__icon wishlist-btn__icon--empty" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '<svg class="wishlist-btn__icon wishlist-btn__icon--filled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '</button>';

    return '<div class="collection-grid__item">' +
      '<div class="card-product card-style--' + CARD_STYLE + (secondaryImgHTML ? ' card-product--has-secondary' : '') + '">' +
        '<a href="' + url + '" class="card-product__link" aria-label="' + escapeAttr(title) + '">' +
          '<div class="card-product__media">' +
            imgHTML +
            secondaryImgHTML +
            '<div class="card-product__badges"><div class="card-product__badges-left"></div><div class="card-product__badges-right">' + shippingBadgeHTML + '</div></div>' +
            buildBadgesHTML(p) +
          '</div>' +
          '<div class="card-product__info">' +
            vendorHTML +
            '<h3 class="card-product__title">' + escapeAttr(title) + '</h3>' +
            buildRatingHTML(p) +
            priceHTML +
          '</div>' +
        '</a>' +
        '<div class="card-product__actions">' + addToCartHTML + wishlistHTML + '</div>' +
      '</div>' +
    '</div>';
  }

  var chevronSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';

  function buildFilterGroup(title, items, dataAttr) {
    if (!items || !items.length) return '';
    var filtered = items.filter(function(v) { return v.count > 0; });
    if (!filtered.length) return '';
    filtered.sort(function(a, b) { return b.count - a.count; });
    var valueItems = '';
    filtered.forEach(function(v) {
      valueItems += '<li class="filter-group__item"><a href="#" class="filter-group__link" ' + dataAttr + '="' + escapeAttr(v.label) + '"><span class="filter-group__checkbox"></span><span class="filter-group__label">' + escapeAttr(v.label) + '</span><span class="filter-group__count">(' + v.count + ')</span></a></li>';
    });
    return '<details class="filter-group"><summary class="filter-group__header"><span class="filter-group__title">' + title + '</span><span class="filter-group__icon">' + chevronSVG + '</span></summary><div class="filter-group__body"><div class="filter-group__scrollable"><ul class="filter-group__list" role="list">' + valueItems + '</ul></div></div></details>';
  }

  function formatFilterPrice(val) {
    var n = Math.round(parseFloat(val));
    return '₺' + n.toLocaleString('tr-TR');
  }

  function buildPriceFilterHTML(products) {
    if (!products || !products.length) return '';
    var minPrice = Infinity, maxPrice = 0;
    products.forEach(function(p) {
      var pr = parseFloat(p.price) || 0;
      if (pr < minPrice) minPrice = pr;
      if (pr > maxPrice) maxPrice = pr;
    });
    if (maxPrice === 0) return '';
    var minInt = Math.floor(minPrice);
    var maxInt = Math.ceil(maxPrice);
    return '<details class="filter-group"><summary class="filter-group__header"><span class="filter-group__title">Fiyat</span><span class="filter-group__icon">' + chevronSVG + '</span></summary><div class="filter-group__body">' +
      '<div class="filter-group__price-range price-range">' +
        '<div class="price-range__slider">' +
          '<div class="price-range__track"><div class="price-range__track-fill" data-price-fill></div></div>' +
          '<input type="range" class="price-range__range price-range__range--min" data-price-filter="min" min="0" max="' + maxInt + '" value="' + minInt + '" step="1">' +
          '<input type="range" class="price-range__range price-range__range--max" data-price-filter="max" min="0" max="' + maxInt + '" value="' + maxInt + '" step="1">' +
        '</div>' +
        '<div class="price-range__display">' +
          '<span data-price-display-min>' + formatFilterPrice(minInt) + '</span>' +
          '<span>&ndash;</span>' +
          '<span data-price-display-max>' + formatFilterPrice(maxInt) + '</span>' +
        '</div>' +
      '</div></div></details>';
  }

  /* Map of known filter keys → display labels and data attributes */
  var FILTER_META = {
    categories: { title: 'Kategoriler', attr: 'data-category-filter', field: 'category' },
    vendors: { title: 'Marka', attr: 'data-vendor-filter', field: 'vendor' },
    gender: { title: 'Cinsiyet', attr: 'data-gender-filter', field: 'gender' },
    spf: { title: 'SPF', attr: 'data-spf-filter', field: 'spf' },
    productForm: { title: 'Ürün Formu', attr: 'data-productform-filter', field: 'productForm' },
    productType: { title: 'Ürün Türü', attr: 'data-producttype-filter', field: 'productType' },
    stockStatus: { title: 'Stok durumu', attr: 'data-stockstatus-filter', field: 'stockStatus' }
  };

  /* Keep ordered rendering: known keys first, then any extras from API */
  var FILTER_ORDER = ['categories', 'vendors', 'gender', 'spf', 'productForm', 'productType', 'stockStatus'];

  function buildFilterHTML(filters, products) {
    var html = '';
    var rendered = {};
    FILTER_ORDER.forEach(function(key) {
      if (filters[key] && filters[key].length) {
        var meta = FILTER_META[key] || { title: key, attr: 'data-' + key + '-filter', field: key };
        html += buildFilterGroup(meta.title, filters[key], meta.attr);
        rendered[key] = true;
      }
    });
    /* Render any extra filter keys not in FILTER_ORDER */
    Object.keys(filters).forEach(function(key) {
      if (rendered[key] || key === 'price') return;
      if (filters[key] && filters[key].length) {
        var meta = FILTER_META[key] || { title: key, attr: 'data-' + key + '-filter', field: key };
        html += buildFilterGroup(meta.title, filters[key], meta.attr);
      }
    });
    html += buildPriceFilterHTML(products);
    return html;
  }

  function buildBrandBarHTML(vendors) {
    if (!vendors || !vendors.length) return '';
    var chevronLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="transform: rotate(90deg)"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    var chevronRight = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="transform: rotate(-90deg)"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    var plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
    var tags = '';
    vendors.forEach(function(v) {
      tags += '<a href="#" class="brand-bar__tag" data-vendor="' + escapeAttr(v.label) + '"><span>' + escapeAttr(v.label) + '</span>' + plusIcon + '</a>';
    });
    return '<brand-scroll class="brand-bar">' +
      '<span class="brand-bar__label">Marka</span>' +
      '<button type="button" class="brand-bar__arrow brand-bar__arrow--left" aria-label="Sola kaydır" hidden>' + chevronLeft + '</button>' +
      '<div class="brand-bar__scroll" data-brand-scroll>' + tags + '</div>' +
      '<button type="button" class="brand-bar__arrow brand-bar__arrow--right" aria-label="Sağa kaydır" hidden>' + chevronRight + '</button>' +
    '</brand-scroll>';
  }

  function shuffleArray(arr) {
    var result = arr.slice();
    for (var i = result.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = result[i]; result[i] = result[j]; result[j] = tmp;
    }
    return result;
  }

  function applyRandomCache(products) {
    var ids = products.map(function(p) { return p.id; });
    var cached = null;
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        cached = JSON.parse(raw);
        if (Date.now() - cached.ts > CACHE_TTL) cached = null;
      }
    } catch(e) { cached = null; }

    if (cached && cached.ids && cached.ids.length === ids.length) {
      var idMap = {};
      products.forEach(function(p) { idMap[p.id] = p; });
      var ordered = [];
      cached.ids.forEach(function(id) { if (idMap[id]) ordered.push(idMap[id]); });
      return ordered;
    }

    var shuffled = shuffleArray(products);
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        ids: shuffled.map(function(p) { return p.id; }),
        ts: Date.now()
      }));
    } catch(e) {}
    return shuffled;
  }

  function loadProducts() {
    var sort = 'collection-default';
    if (SOURCE_TYPE === 'random') sort = 'random';
    else if (SOURCE_TYPE === 'best_selling') sort = 'best-selling';

    var params = [
      'collection=' + encodeURIComponent(COLLECTION_HANDLE),
      'limit=' + MAX_PRODUCTS,
      'sort=' + sort
    ];
    if (HIDE_SOLD_OUT) params.push('available=true');
    if (HIDE_NO_IMAGE) params.push('hide_no_image=true');
    if (ONE_PER_VENDOR) params.push('one_per_vendor=true');

    var url = '/apps/wishlist/popular-products?' + params.join('&');

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(result) {
        if (!result.products || result.products.length === 0) {
          if (loadingEl) loadingEl.style.display = 'none';
          grid.style.display = '';
          grid.innerHTML = '<div class="collection-empty empty-state"><p>Ürün bulunamadı.</p></div>';
          return;
        }

        var products = result.products;

        if (SOURCE_TYPE === 'random') {
          products = applyRandomCache(products);
        }

        allLoadedProducts = products;

        if (loadingEl) loadingEl.style.display = 'none';
        grid.style.display = '';

        if (countEl) {
          countEl.textContent = '(' + products.length + ' ürün)';
        }

        var cardsHTML = '';
        products.forEach(function(p) {
          cardsHTML += buildCardHTML(p);
        });
        grid.innerHTML = cardsHTML;

        // Filtreler
        var filters = result.filters || {};

        if (filterSidebar) {
          filterSidebar.innerHTML = buildFilterHTML(filters, products);
        }

        if (brandBar) {
          brandBar.innerHTML = buildBrandBarHTML(filters.vendors || []);
        }

        // Wishlist butonlarını init et
        if (typeof MutluFiyatlar !== 'undefined' && MutluFiyatlar.initWishlistButtons) {
          MutluFiyatlar.initWishlistButtons();
        }

        // Filtre tıklama event'leri
        bindVendorFilters();
        bindCategoryFilters();
        bindMetaFilters(filters);
        bindPriceFilter();

      }).catch(function(err) {
        console.error('[PopularProducts] API error:', err);
        if (loadingEl) loadingEl.style.display = 'none';
        grid.style.display = '';
        grid.innerHTML = '<div class="collection-empty empty-state"><p>Ürünler yüklenirken hata oluştu.</p></div>';
      });
  }

  var activeVendors = {};
  var activeCategories = {};
  var activeMetaFilters = {}; /* key → { value: true/false } */
  var priceMin = null;
  var priceMax = null;
  var allLoadedProducts = [];

  function applyAllFilters() {
    var hasVendorFilter = Object.keys(activeVendors).some(function(k) { return activeVendors[k]; });
    var hasCategoryFilter = Object.keys(activeCategories).some(function(k) { return activeCategories[k]; });

    /* Build active meta filter lookup */
    var activeMetaKeys = {};
    Object.keys(activeMetaFilters).forEach(function(key) {
      var hasActive = Object.keys(activeMetaFilters[key]).some(function(v) { return activeMetaFilters[key][v]; });
      if (hasActive) activeMetaKeys[key] = true;
    });

    var filtered = allLoadedProducts.filter(function(p) {
      if (hasVendorFilter && !activeVendors[p.vendor]) return false;
      if (hasCategoryFilter) {
        var pCat = p.category || p.productType || '';
        if (!activeCategories[pCat]) return false;
      }
      /* Dynamic meta filters */
      for (var fk in activeMetaKeys) {
        var meta = FILTER_META[fk] || { field: fk };
        var pVal = p[meta.field] || '';
        if (!activeMetaFilters[fk][pVal]) return false;
      }
      var pr = parseFloat(p.price) || 0;
      if (priceMin !== null && pr < priceMin) return false;
      if (priceMax !== null && pr > priceMax) return false;
      return true;
    });

    var cardsHTML = '';
    filtered.forEach(function(p) { cardsHTML += buildCardHTML(p); });
    grid.innerHTML = cardsHTML;

    if (countEl) countEl.textContent = '(' + filtered.length + ' ürün)';

    if (typeof MutluFiyatlar !== 'undefined' && MutluFiyatlar.initWishlistButtons) {
      MutluFiyatlar.initWishlistButtons();
    }
  }

  function bindVendorFilters() {
    container.querySelectorAll('[data-vendor-filter]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var vendor = this.getAttribute('data-vendor-filter');
        activeVendors[vendor] = !activeVendors[vendor];
        this.classList.toggle('filter-group__link--active', activeVendors[vendor]);
        applyAllFilters();
      });
    });

    container.querySelectorAll('[data-vendor]').forEach(function(tag) {
      tag.addEventListener('click', function(e) {
        e.preventDefault();
        var vendor = this.getAttribute('data-vendor');
        activeVendors[vendor] = !activeVendors[vendor];
        this.classList.toggle('brand-bar__tag--active', activeVendors[vendor]);
        var iconEl = this.querySelector('svg');
        if (iconEl) {
          if (activeVendors[vendor]) {
            iconEl.innerHTML = '<line x1="5" y1="12" x2="19" y2="12"></line>';
          } else {
            iconEl.innerHTML = '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>';
          }
        }
        container.querySelectorAll('[data-vendor-filter="' + vendor + '"]').forEach(function(link) {
          link.classList.toggle('filter-group__link--active', activeVendors[vendor]);
        });
        applyAllFilters();
      });
    });
  }

  function bindCategoryFilters() {
    container.querySelectorAll('[data-category-filter]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var cat = this.getAttribute('data-category-filter');
        activeCategories[cat] = !activeCategories[cat];
        this.classList.toggle('filter-group__link--active', activeCategories[cat]);
        applyAllFilters();
      });
    });
  }

  function bindMetaFilters(filters) {
    /* Bind click handlers for all dynamic (non-vendor, non-category) filter groups */
    var skipKeys = { categories: true, vendors: true, price: true };
    Object.keys(filters).forEach(function(key) {
      if (skipKeys[key] || !filters[key] || !filters[key].length) return;
      var meta = FILTER_META[key] || { attr: 'data-' + key + '-filter', field: key };
      var attr = meta.attr;
      container.querySelectorAll('[' + attr + ']').forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var val = this.getAttribute(attr);
          if (!activeMetaFilters[key]) activeMetaFilters[key] = {};
          activeMetaFilters[key][val] = !activeMetaFilters[key][val];
          this.classList.toggle('filter-group__link--active', activeMetaFilters[key][val]);
          applyAllFilters();
        });
      });
    });
  }

  function bindPriceFilter() {
    var minInput = container.querySelector('[data-price-filter="min"]');
    var maxInput = container.querySelector('[data-price-filter="max"]');
    if (!minInput || !maxInput) return;

    var fill = container.querySelector('[data-price-fill]');
    var displayMin = container.querySelector('[data-price-display-min]');
    var displayMax = container.querySelector('[data-price-display-max]');
    var rangeMax = parseFloat(maxInput.max) || 1;

    function updateTrackFill() {
      if (!fill) return;
      var lo = parseFloat(minInput.value);
      var hi = parseFloat(maxInput.value);
      var leftPct = (lo / rangeMax) * 100;
      var rightPct = (hi / rangeMax) * 100;
      fill.style.left = leftPct + '%';
      fill.style.width = (rightPct - leftPct) + '%';
    }

    function onMinInput() {
      var lo = parseFloat(minInput.value);
      var hi = parseFloat(maxInput.value);
      if (lo > hi) minInput.value = hi;
      updateTrackFill();
      if (displayMin) displayMin.textContent = formatFilterPrice(minInput.value);
    }

    function onMaxInput() {
      var lo = parseFloat(minInput.value);
      var hi = parseFloat(maxInput.value);
      if (hi < lo) maxInput.value = lo;
      updateTrackFill();
      if (displayMax) displayMax.textContent = formatFilterPrice(maxInput.value);
    }

    function onPriceChange() {
      priceMin = parseFloat(minInput.value) || null;
      priceMax = parseFloat(maxInput.value) || null;
      applyAllFilters();
    }

    minInput.addEventListener('input', onMinInput);
    maxInput.addEventListener('input', onMaxInput);
    minInput.addEventListener('change', onPriceChange);
    maxInput.addEventListener('change', onPriceChange);

    updateTrackFill();
  }

  loadProducts();
})();
